import React from 'react';
import Typography from "@material-ui/core/Typography";
import { validacionWalmart} from "../endpoints";
import MaterialTable, {MTableToolbar} from "material-table";
import tableicons from "../tableicons";
import SnackbarAlert from "../components/SnackbarAlert";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import DialogAgregarEditarRNR from "../components/DialogAgregarEditarRNR";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

class RNR extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            rnr:[],
            selectedRow: null,
            editar: false,
            agregar:false,
        }
    }

    handleClose = () =>{
        this.setState({agregar:false,editar:false})
    }

    getRnr (){
        validacionWalmart.getRnr().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({rnr:result.rnr})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }
    eliminarRNR= (rowData) =>{
        validacionWalmart.deleteRnr(rowData.id).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
            this.getRnr()
        }).catch(error=> {
            console.log(error)
            this.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }

    refrescar = (estado,severity) =>{
        this.setState({ openSnack:false, severity: null, message:null, agregar:false,editar:false}, ()=>
        {
            this.setState({openSnack:true, severity:severity, message:estado})
        })
        this.getRnr()

    }

    componentDidMount() {
        this.getRnr()
    }

    para_editar_rnr = (rowData) =>{
        this.setState({id:rowData.id, depto:rowData.depto, cantidad:rowData.cantidad,importe:rowData.importe ,editar:true})
    }

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>
                    RNR
                </Typography>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    isLoading={this.state.cargando}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title={""}
                    data={this.state.rnr}
                    columns={[
                        { title: 'Depto', field: 'depto',
                            cellStyle: {
                                width: 250,
                                maxWidth: 250,
                            },
                            headerStyle: {
                                width: 250,
                                maxWidth: 250
                            }},
                        { title: 'Cantidad', field: 'cantidad',
                            cellStyle: {
                                width: 950,
                                maxWidth: 950,
                            },
                            headerStyle: {
                                width: 950,
                                maxWidth: 950
                            }},
                        { title: 'Importe', field: 'importe',
                            cellStyle: {
                                width: 950,
                                maxWidth: 950,
                            },
                            headerStyle: {
                                width: 950,
                                maxWidth: 950
                            }},
                    ]}
                    components={{
                        Toolbar: props => (
                            <div>
                                <MTableToolbar {...props} />
                                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                                    <Grid item>
                                        <Button variant="contained" name="avance" color="primary" onClick={() => this.setState({agregar:true})}>
                                            Agregar RNR</Button>
                                    </Grid>
                                </Grid>
                            </div>
                        ),
                    }}
                    actions={[
                        {
                            icon:  () => <CreateIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Editar RNR',
                            onClick: (event, rowData) => this.para_editar_rnr(rowData),
                        },
                        {
                            icon:  () => <DeleteIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Eliminar RNR',
                            onClick: (event, rowData) => this.eliminarRNR(rowData),
                        }
                    ]}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.editar ? <DialogAgregarEditarRNR handleClose={this.handleClose} id={this.state.id} depto={this.state.depto} cantidad={this.state.cantidad} importe={this.state.importe} refrescar={this.refrescar}/>:null }
                {this.state.agregar ? <DialogAgregarEditarRNR handleClose={this.handleClose} depto={null} cantidad={null} importe={null} refrescar={this.refrescar}/>:null}
            </div>
        )}
}

export default RNR;
